import { EventEmitter } from "events";
import cloudDispatcher from "./CloudDispatcher";
import { authentications, profiles, roles } from "../authorization/authorizations";

export const cloudStoreActions = {
  SET_MERCHANT: "SET_MERCHANT",
  SET_TA_MERCHANT: "SET_TA_MERCHANT",
  SET_SP_MERCHANT: "SET_SP_MERCHANT",
  SET_PILLAR_MERCHANT: "SET_PILLAR_MERCHANT",
  SET_FILTERED_MERCHANTS: "SET_FILTERED_MERCHANTS",
  SET_MERCHANTS: "SET_MERCHANTS",
  SET_TAKEAWAY_DELIVERY_SETTINGS: "SET_TAKEAWAY_DELIVERY_SETTINGS",
  SET_ROLES: "SET_ROLES",
  SET_USER_ROLES: "SET_USER_ROLES",
  SET_PROFILES: "SET_PROFILES",
  SET_USER_PROFILES: "SET_USER_PROFILES",
  SET_AUTHENTICATIONS: "SET_AUTHENTICATIONS",
  SET_LOADING: "SET_LOADING",
};

export const cloudStoreEvents = {
  MERCHANT_UPDATED: "MERCHANT_UPDATED",
  TA_MERCHANT_UPDATED: "TA_MERCHANT_UPDATED",
  SP_MERCHANT_UPDATED: "SP_MERCHANT_UPDATED",
  PILlAR_MERCHANT_UPDATED: "PILlAR_MERCHANT_UPDATED",
  FILTERED_MERCHANTS_UPDATED: "FILTERED_MERCHANTS_UPDATED",
  TAKEAWAY_DELIVERY_SETTINGS_UPDATED: "TAKEAWAY_DELIVERY_SETTINGS_UPDATED",
  ROLES_UPDATED: "ROLES_UPDATED",
  PROFILES_UPDATED: "PROFILES_UPDATED",
  USER_ROLES_UPDATED: "USER_ROLES_UPDATED",
  USER_PROFILES_UPDATED: "USER_PROFILES_UPDATED",
  AUTHENTICATIONS_UPDATED: "AUTHENTICATIONS_UPDATED",
  LOADING_UPDATED: "LOADING_UPDATED",
};

class CloudStore extends EventEmitter {
  constructor() {
    super();

    // Variables related to CloudStore.
    this.merchant = null;
    this.taMerchant = null;
    this.spMerchant = null;
    this.pillarMerchant = null;
    this.merchants = null;
    this.filteredMerchants = [];
    this.takeawayDeliverySettings = {};
    this.userRoles = null;
    this.userProfiles = null;
    this.roles = roles.sort();
    this.profiles = profiles.sort();
    this.authentications = authentications;
    this.loading = false;
  }

  addChangeListener(callback) {
    this.on(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, callback);
    this.on(cloudStoreEvents.MERCHANT_UPDATED, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(cloudStoreEvents.MERCHANT_UPDATED, callback);
    this.removeListener(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED, callback);
  }

  emitChange() {
    this.emit(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED);
  }

  /**
   * Action handler for CloudStore.
   * @param {object} action
   */
  _handleActions(action) {
    switch (action.type) {
      case cloudStoreActions.SET_MERCHANT:
        this.merchant = action.merchant;
        this.emit(cloudStoreEvents.MERCHANT_UPDATED);
        break;
      case cloudStoreActions.SET_FILTERED_MERCHANTS:
        this.filteredMerchants = action.filteredMerchants;
        this.emit(cloudStoreEvents.FILTERED_MERCHANTS_UPDATED);
        break;
      case cloudStoreActions.SET_MERCHANTS:
        this.merchants = action.merchants;
        break;
      case cloudStoreActions.SET_TAKEAWAY_DELIVERY_SETTINGS:
        this.takeawayDeliverySettings = action.takeawayDeliverySettings;
        break;
      case cloudStoreActions.SET_ROLES:
        this.roles = action.roles;
        this.emit(cloudStoreEvents.ROLES_UPDATED);
        break;
      case cloudStoreActions.SET_PROFILES:
        this.profiles = action.profiles;
        this.emit(cloudStoreEvents.PROFILES_UPDATED);
        break;
      case cloudStoreActions.SET_USER_ROLES:
        this.userRoles = action.userRoles;
        this.emit(cloudStoreEvents.USER_ROLES_UPDATED);
        break;
      case cloudStoreActions.SET_USER_PROFILES:
        this.userProfiles = action.userProfiles;
        this.emit(cloudStoreEvents.USER_PROFILES_UPDATED);
        break;
      case cloudStoreActions.SET_AUTHENTICATIONS:
        this.authentications = action.authentications;
        this.emit(cloudStoreEvents.AUTHENTICATIONS_UPDATED);
        break;
      case cloudStoreActions.SET_TA_MERCHANT:
        {
          this.taMerchant = action.taMerchant;
          let index = this.merchant.ta_merchants.findIndex((ta_merchant) => ta_merchant.id === this.taMerchant.id);
          if (index !== -1) {
            Object.keys(this.taMerchant).forEach((key) => {
              this.merchant.ta_merchants[index][key] = this.taMerchant[key];
            });
          }
          this.emit(cloudStoreEvents.TA_MERCHANT_UPDATED);
        }
        break;
      case cloudStoreActions.SET_SP_MERCHANT:
        {
          this.spMerchant = action.spMerchant;
          let index = this.merchant.sp_merchants.findIndex((sp_merchant) => sp_merchant.id === this.spMerchant.id);
          if (index !== -1) {
            Object.keys(this.spMerchant).forEach((key) => {
              this.merchant.sp_merchants[index][key] = this.spMerchant[key];
            });
          }
          this.emit(cloudStoreEvents.SP_MERCHANT_UPDATED);
        }
        break;
      case cloudStoreActions.SET_PILLAR_MERCHANT:
        this.pillarMerchant = action.pillarMerchant;
        let index = this.merchant.pillar_merchants.findIndex(
          (ta_merchant) => ta_merchant.id === this.pillarMerchant.id
        );
        if (index !== -1) {
          Object.keys(this.pillarMerchant).forEach((key) => {
            this.merchant.pillar_merchants[index][key] = this.pillarMerchant[key];
          });
        }
        this.emit(cloudStoreEvents.TA_MERCHANT_UPDATED);
        break;
      case cloudStoreActions.SET_LOADING:
        this.loading = action.loading;
        this.emit(cloudStoreEvents.LOADING_UPDATED);
      default:
        break;
    }
  }
}

const cloudStore = new CloudStore();
cloudDispatcher.register(cloudStore._handleActions.bind(cloudStore));
export default cloudStore;
window.cloudStore = cloudStore;
